import { useRef, ReactNode, useEffect, useState } from "react"

import styled from "styled-components"

import { useOnResize } from "../../hooks/use-on-resize"

const Outer = styled.div<{ height: number }>`
  height: 0px;
  transition: height 0.3s ease-in-out;
  overflow: hidden;
  position: relative;
  ${({ height }) => `height: ${height}px;`}
`

const Inner = styled.div`
  position: absolute;
  width: 100%;
`

type ExpanderProps = {
  children: ReactNode
  id?: string
}

export const Expander = ({ children, id }: ExpanderProps) => {
  const refContent = useRef<HTMLDivElement>(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    refContent.current && setHeight(refContent.current.clientHeight)
  }, [children])

  useOnResize(() => {
    refContent.current && setHeight(refContent.current.clientHeight)
  }, [children])

  return (
    <Outer height={height}>
      <Inner id={id} ref={refContent}>
        {children}
      </Inner>
    </Outer>
  )
}
